export const GoogleMapApiConfig =
  process.env.REACT_APP_GOOGLE_MAPS_KEY ||
  "AIzaSyDIxxftHVbP4DOZIXeDJNomltwGDQTHuts";
